// extracted by mini-css-extract-plugin
export default {"root":"LV9vf","disclaimer":"z6zM5","disclaimerLink":"_2qAC","spinner":"xM1ov"};